"use strict";
/**
 * Created by Ning Jiang on 8/29/2019.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvalancheReelEvent = void 0;
class AvalancheReelEvent {
}
AvalancheReelEvent.REEL_STOP_SPIN_SYMBOL_ATTENTION_START = "avalancheReelEvent_reelStopSpinSymbolAttentionStart";
AvalancheReelEvent.ALL_REELS_AVALANCHE_STARTED = "avalancheReelEvent_allReelsAvalancheStarted";
AvalancheReelEvent.REEL_AVALANCHE_COMPLETE = "avalancheReelEvent_reelAvalancheComplete";
AvalancheReelEvent.ALL_REELS_AVALANCHE_COMPLETE = "avalancheReelEvent_allReelsAvalancheComplete";
exports.AvalancheReelEvent = AvalancheReelEvent;
//# sourceMappingURL=AvalancheReelEvent.js.map